// import { useParams } from 'react-router-dom'
import { FindYourMatch } from "../../molecules/FindYourMatch/FindYourMatch";
import { CardCompanyResult, CustomTable } from "../../molecules";
import Footer from "../../organism/Footer/Footer";
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext";
import { FindAStartup } from "../../molecules/FindAStartup/FindAStartup";
import { Corporate, MatchDate, ModalType, StartUp } from "../../types/types";
import { LoginType } from "components/types/Context";
import { Link, useNavigate } from "react-router-dom";
import clsx from "clsx";
import { getStartUpByID, postStartupStartMatch } from "api/Api";
import useMediaQuery from "hook/useMediaQuery";
import { MediaTablet } from "api/const/MediaQuery";
import useIntersection from "hook/useIntersection";
import { Loader, TitlePage } from "components/atoms";
import { ProfileCorporateEdit } from "./Corporate";
import { ProfileStartUpEdit } from "./StartUp";
import {
  initialPager,
  initialReqCorporate,
  initialReqStartup,
} from "components/types/InitialData";
import { useGuestView } from "shared/GeneralContext/GuestContext";
import { useAuth } from "shared/auth";
import { BannerMenu, ViewChart } from "components/organism";

export const Profile = () => {
  const {
    loginType,
    corporatesList,
    numberMatchRequest,
    setNumberMatchRequest,
    getCorporatesList,
    isLoadingCorporates,
    setPagerCorporatesList,
    pagerCorporatesList,
    setReqCorporate,
    reqCorporate,
    getStartupsList,
    isLoadingStartups,
    setPagerStartupsList,
    pagerStartupsList,
    setReqStartup,
    reqStartup,
    startupsList,
    startUp,
    user,
    setStartupsList,
    setModalDatesIsOpen,
    setModal,
    setstartUpIdforMatch,
    setErrorModal,
    setLoadingModal,
    setCorporatesList,
    setMatchCallDates,
    getMatchList,
  } = useContext(AppGeneralContext);
  const navigate = useNavigate();
  const tablet = useMediaQuery(MediaTablet);
  const [selectedId, setSelectedId] = useState<string>("");
  const refBottom = useRef<HTMLDivElement | any>();
  const inViewport = useIntersection(refBottom, "10px");
  const { auth } = useAuth();
  const { userGuest, setUserGuest, resetGuest, canMatch, setCanMatch } =
    useGuestView();

  useEffect(() => {
    setReqCorporate(initialReqCorporate);
    setReqStartup(initialReqStartup);
    setPagerCorporatesList(initialPager);
    setPagerStartupsList(initialPager);
    setStartupsList([]);
    setCorporatesList([]);
    return () => {
      window.scrollTo(0, 0);
      setStartupsList([]);
      setCorporatesList([]);
      setReqCorporate(initialReqCorporate);
      setReqStartup(initialReqStartup);
      setPagerCorporatesList(initialPager);
      setPagerStartupsList(initialPager);
    };
  }, []);

  function startGuestMatch(
    date1: string,
    date2: string,
    date3: string,
    startupID: string,
    storage: boolean
  ) {
    let dates: MatchDate[] = [
      {
        id: "firstDate",
        date: date1,
      },
      {
        id: "secondDate",
        date: date2,
      },
      {
        id: "thirdDate",
        date: date3,
      },
    ];

    getStartUpByID(startupID).then((res) => {
      let resp = res.response?.data;
      if (resp) {
        setCanMatch(resp?.canMatch);
        setMatchCallDates(dates);
        navigate(`/corporate/startup-profile/${startupID}`);
        setModalDatesIsOpen(true);
        resetGuest(storage);
      } else {
        setModalDatesIsOpen(false);
      }
    });
  }

  useEffect(() => {
    if (loginType === LoginType.corporate) {
      let uG = localStorage.getItem("userGuest");
      if (uG && uG !== "undefined") {
        //wat
        let userGuestLocal = JSON.parse(uG);

        if (
          userGuestLocal !== undefined &&
          userGuestLocal.featuredStartupID &&
          userGuestLocal.date1 &&
          userGuestLocal.date2 &&
          userGuestLocal.date3
        ) {
          startGuestMatch(
            userGuestLocal.date1,
            userGuestLocal.date2,
            userGuestLocal.date3,
            userGuestLocal.featuredStartupID,
            true
          );
        }
        return;
      }

      if (
        userGuest &&
        userGuest.featuredStartupID &&
        userGuest.date1 &&
        userGuest.date2 &&
        userGuest.date3
      ) {
        startGuestMatch(
          userGuest.date1,
          userGuest.date2,
          userGuest.date3,
          userGuest.featuredStartupID,
          false
        );
        return;
      }
    }
  }, [userGuest]);

  useEffect(() => {
    if (
      loginType === LoginType.corporate &&
      userGuest &&
      userGuest.featuredStartupID &&
      userGuest.date1 &&
      userGuest.date2 &&
      userGuest.date3
    ) {
      navigate(`/corporate/startup-profile/${userGuest.featuredStartupID}`);
      setModalDatesIsOpen(true);
    } else {
      setModalDatesIsOpen(false);
    }
  }, [userGuest, loginType]);

  useEffect(() => {
    if (inViewport?.isVisible) {
      if (loginType === LoginType.startup) {
        if (isLoadingCorporates) {
          return;
        }

        // if (startUp.currentPlan?.monthMatches === 0 || numberMatchRequest <= 0) {
        //     return
        // }

        if (pagerCorporatesList.pageNum < pagerCorporatesList.totalPages) {
          setReqCorporate({
            ...reqCorporate,
            pageNum: pagerCorporatesList?.pageNum + 1,
          });
          return;
        }

        return;
      }

      if (loginType === LoginType.corporate) {
        if (isLoadingStartups) {
          return;
        }

        if (pagerStartupsList.pageNum < pagerStartupsList.totalPages) {
          setReqStartup({
            ...reqStartup,
            pageNum: pagerStartupsList?.pageNum + 1,
          });
          return;
        }
        return;
      }

      return;
    }
  }, [
    inViewport.isVisible,
    loginType,
    pagerCorporatesList,
    pagerStartupsList,
    startUp.currentPlan?.monthMatches,
    numberMatchRequest,
    isLoadingCorporates,
    isLoadingStartups,
  ]);

  useEffect(() => {
    if (!auth?.jwtToken || !loginType) {
      return;
    }

    if (loginType === LoginType.startup && corporatesList?.length === 0) {
      getCorporatesList();
      return;
    }

    if (loginType === LoginType.corporate && startupsList?.length === 0) {
      setSelectedId("");
      let logged = auth?.jwtToken ? true : false;
      getStartupsList(logged);
      return;
    }
  }, [loginType, corporatesList?.length, startupsList?.length, auth?.jwtToken]);

  useEffect(() => {
    if (!auth?.jwtToken || !loginType) {
      return;
    }

    if (loginType === LoginType.startup && reqCorporate.pageNum > 0) {
      getCorporatesList();
      return;
    }

    if (loginType === LoginType.corporate && reqStartup.pageNum > 0) {
      setSelectedId("");
      let logged = auth?.jwtToken ? true : false;
      getStartupsList(logged);
      return;
    }
  }, [loginType, auth?.jwtToken, reqCorporate, reqStartup]);

  const Match = (id: string) => {
    getMatchList();
    setstartUpIdforMatch(id);
    setModalDatesIsOpen(true);
  };

  const ViewProfile = (id: string | undefined) => {
    //FIX 2/12/24
    window.open(`/corporate/startup-profile/${id}`, "_blank");
    //instead of
    //navigate(`/corporate/startup-profile/${id}`,{})
  };

  const askForaMatch = useCallback(
    (
      userId: string,
      companyName: string,
      userName: string,
      companyId: string
    ) => {
      // if (
      //     // startUp.currentPlan?.monthMatches === 0 ||
      //     numberMatchRequest <= 0) {
      //     return
      // }

      setLoadingModal();
      postStartupStartMatch({ userId }).then((res) => {
        if (!res.isSuccess || !res.response) {
          setErrorModal(res.error);
          return;
        }

        setModal({
          isOpen: true,
          type: ModalType.info,
          title: "Ask for a Match confirmed!",
          message: `Your request to ${companyName} has been sent`,
        });

        if (loginType === LoginType.startup) {
          const updatedList = corporatesList?.map((c: Corporate) => {
            if (c.id === companyId) {
              const companyUsers = c.users?.map((u) => {
                if (u.value === userId) {
                  return {
                    ...u,
                    canMatch: false,
                    unmatchableReason: "Match in progress",
                  };
                }
                return u;
              });

              return { ...c, users: companyUsers } as Corporate;
            }
            return c;
          });

          setCorporatesList(updatedList as Corporate[]);
          // getCorporatesList()
          if (numberMatchRequest >= 1) {
            setNumberMatchRequest(numberMatchRequest - 1);
            getMatchList();
          }
        } else if (loginType === LoginType.corporate) {
          let logged = auth?.jwtToken ? true : false;
          getStartupsList(logged);
        }
      });
    },
    [loginType, numberMatchRequest, corporatesList, auth]
  );

  const showCard = useMemo(() => {
    if (startupsList && startupsList.length !== 0) {
      return startupsList.map((el: StartUp, index) => {
        return (
          <CardCompanyResult
            key={el?.id + index.toString()}
            title={el?.name}
            description={el?.description}
            category={el?.department?.label}
            squareImage={el.logoUrl}
            backgroundImage={el.coverUrl}
            profileCallback={() => ViewProfile(el?.id)}
            matchCallback={Match}
            id={el.id ?? ""}
            canMatch={el.canMatch}
            unmatchableReason={el.unmatchableReason}
            tags={el?.tags}
          />
        );
      });
    }

    return (
      <div className="w-100 text-center mt-4 mb-5">
        <h6>No result</h6>
      </div>
    );
  }, [startupsList]);

  const table = useMemo(() => {
    if (corporatesList && corporatesList.length > 0) {
      // if (startUp.currentPlan?.monthMatches === 0 || numberMatchRequest <= 0) {
      //     return (
      //         <div className="relative w-100 d-flex align-items-center justify-content-center ">
      //             {!tablet && <CustomTable data={corporatesList} askForaMatch={askForaMatch} selectedId={selectedId} setSelectedId={setSelectedId} />}
      //             <div className="absolute   d-flex  align-items-center justify-content-center w-100">
      //                 <div className='upgrade-plan-pop-up tx-center d-flex  flex-column align-items-center justify-content-center'>
      //                     <Link to="/start-up/profile/upgrade-plan" className='tx-primary tx-center  d-flex justify-content-center tx-underline cursor-pointer'> <h4 className='txt-center'>Upgrade your plan!</h4></Link>
      //                     <h4 className='m-0 p-0 '>to ask for a Match</h4>
      //                 </div>
      //             </div>
      //         </div>
      //     )
      // }

      return (
        <CustomTable
          data={corporatesList}
          askForaMatch={askForaMatch}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
        />
      );
    }

    return (
      <div className="w-100 text-center mt-4 mb-5">
        <h6>No result</h6>
      </div>
    );
  }, [corporatesList, tablet, selectedId, setSelectedId, inViewport.isVisible]);

  const profileStartUp = useMemo(() => {
    return <ProfileStartUpEdit />;
  }, [loginType, user, user?.role, startUp]);

  return (
    <div className={clsx("px-4")}>
      <div className="row ">
        <div className="col-12">
          {loginType === LoginType.startup ? (
            profileStartUp
          ) : (
            <ProfileCorporateEdit />
          )}
        </div>
      </div>
      {loginType === LoginType.startup ? (
        <>
          <ViewChart />
          <BannerMenu />
          <FindYourMatch setSelectedId={setSelectedId} />
          <div className="row table-col ">
            <div className="col-12 ">
              {table}
              {isLoadingCorporates && <Loader />}
            </div>
          </div>
        </>
      ) : (
        <>
          <FindAStartup />
          <div className="row table-col">
            <div
              className={clsx(
                "w-100  d-flex justify-content-center m-0 p-0 flex-wrap ",
                { "ms-1": tablet }
              )}
            >
              {showCard}
              {isLoadingStartups && <Loader />}
              {/* <div ref={refBottomCard}></div> */}
            </div>
          </div>
        </>
      )}
      <div className="" ref={refBottom} style={{ height: "4px" }} />
      <Footer />
    </div>
  );
};
